import { render, staticRenderFns } from "./OnlineConsultDrawer.vue?vue&type=template&id=122b8b46&scoped=true&"
import script from "./OnlineConsultDrawer.vue?vue&type=script&lang=js&"
export * from "./OnlineConsultDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OnlineConsultDrawer.vue?vue&type=style&index=0&id=122b8b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b8b46",
  null
  
)

export default component.exports